import { makeStyles } from 'tss-react/mui';

import { BorderRadius } from '../Theme';

export const useStyles = makeStyles<{
  radius?: keyof BorderRadius;
}>()((theme, { radius }) => ({
  body: {
    backgroundColor: theme.tokens.colors.bg.greyscale.primary,
  },
  text: {
    borderRadius: theme.tokens.radius.s,
  },
  rect: {
    borderRadius: theme.tokens.radius.l,
  },
  circle: {
    borderRadius: theme.tokens.radius.round,
  },
  radius: {
    borderRadius: theme.tokens.radius[radius as keyof BorderRadius],
  },
}));
